import { FC } from 'react';
import { Heading } from '../../../../shared/Heading';
import { Decorator } from 'components/shared/Decorator';
import { Content } from 'api/maintestApi';

import { Texts } from 'components/shared/Texts';
import styles from './Summary.module.scss';

interface SummaryProps {
  header: string;
  summary?: Content;
}

export const Summary: FC<SummaryProps> = ({ header = '', summary }) => {
  return (
    <section className={styles.summary}>
      <Heading type="h2">{header}</Heading>
      <Decorator className={styles.decorator} />
      <div className={styles.columns}>
        <div className={styles.img_wrapper}>
          <img className={styles.logo} src="/motylek.png" alt="Logo Empatii" />
        </div>
        <div className={styles.desc}>
          {summary?.content?.map((data, i) =>
            data.url !== undefined ? (
              <a key={`Summary_${i}`} href={data.url} target="_blank">
                {data.text}
              </a>
            ) : (
              <Texts key={`Summary_${i}`} className={styles.text}>
                {data.text}
              </Texts>
            )
          )}
        </div>
      </div>
    </section>
  );
};
